import React from 'react';
import {
    Username,
    Designation,
    Usercode,
    Proxyfor,
} from './userProxyPanel.styled';
import { useTranslation } from 'react-i18next';

const UserProxyPanel = () => {
    const { t } = useTranslation();
    return (
        <>
            <Proxyfor>{t('proxies.proxyBanner.proxyFor')}</Proxyfor>
            <Username>{sessionStorage.getItem('ProxyUser')}</Username>
            <Designation>{sessionStorage.getItem('ProxyUserRole')}</Designation>
            <Usercode>{sessionStorage.getItem('ProxyDistrict')}</Usercode>
        </>
    );
};

export default UserProxyPanel;
